import { useCallback, useEffect, useRef, useState } from "react";
import {
  TextField,
  InputAdornment,
} from "@mui/material";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckIcon from '@mui/icons-material/Check';
import { popupType } from "../../../types/types";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { Loader } from "../../../components/loader/Loader";
import { ConfirmationPopUp } from "../../../components/popup/confirmationPopUp";
import { GenericPopUp } from "../../../components/popup/genericPopUp";
import FormHeader from "../../../components/dms_common/FormHeader";
import Header from "../../../components/dms_common/Header";
import CustomDataGrid from "../../../components/dms_common/CustomDataGrid";
import { viewClaimMetaData1, viewClaimMetaData2 } from "../utils/OpenClaimsDetailsUtils";
import { formatDecimal } from "../../../components/dms_common/DmsUtils";
import OpenClaimsDetailsModal from '../modals/OpenClaimsDetailsModal';
import { useDispatch, useSelector } from "react-redux";
import CustomAccordian from "../../../components/dms_common/CustomAccordian";
import { getClaimDetails, getClaimApprovalDetails } from "../../../services/claimService";
import { getClaimsDetailsColumnsMetaData } from "../utils/ViewClaimsUtils";
import {getLastNPathSegments, getBlobUrlForSku, ApprovalConfig, transformApprovalData} from "../utils/utils";
import { setOpenClaimsRow, setSelectedOpenClaimsRow, setSaleReturnsCheckedClaimIds, setSaleReturnsClaimIdsCheckboxHidden } from "../../../stateManagement/actions/claims";
import { capitalize } from "../../../utils/utils";
import { getConfigData } from "../../../services/configurationService";
import store from "../../../stateManagement/store";
import ClaimActionConfirmationModal from "../modals/ClaimActionConfirmationModal";
import ClaimRejectionModal from "../modals/ClaimRejectionModal";
import ClaimDetailsModal from '../../../components/claims/viewClaimStatus/ClaimDetailsModal';
import {getMetaData} from "../../../services/uiConfigService"; 
import { getDataFromLocalDb } from "../../../services/dbService";
import { logLoadTrace } from "../../../../src/firebase";
import { handleScroll, handleScrollCustomDataGrid } from "../../../components/dms_common/DmsUtils";

const OpenClaimsDetails = () => {
  const {saleReturnsCheckedClaimIds, openClaimsRows, selectedOpenClaimsRow, saleReturnsClaimIdsCheckboxHidden} = useSelector(
    (state: any) => state.claims
  );
  const sidebarCollapsed: boolean = useSelector(
    () => store.getState().sidebarState.sidebarCollapsed
  );
  const navigate = useNavigate();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const claimId = query.get('claimId') || "0";
  const dispatch = useDispatch();
  const [approvalModalOpen, setApprovalModalOpen] = useState(false);
  const [approvalModalState, setApprovalModalState] = useState(1);
  const [approveModalType, setApproveModalType] = useState<'full' | 'partial' | 'rejectFull' | 'rejectPartial'>('full');
  const [pendingItemsCount, setPendingItemsCount] = useState(0);
  const [data, setData] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [openClaimsOthersUIConfig, setOpenClaimsOthersUIConfig] = useState<any>({});
  const [actionButtons, setActionButtons] = useState<any[]>([]);
  const [accordionData, setAccordionData] = useState<any>({});
  const [isScrolling, setIsScrolling] = useState(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [filteredRows, setFilteredRows] = useState<any[]>([]);
  const postBodyRef = useRef<any>(null);
  const popUpSuccessMethod = useRef<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [rejectionReasons, setRejectionReasons] = useState<Record<string, string>>({});
  const [canApproveReject, setCanApproveReject] = useState<boolean>(true);
  const [approvalConfig, setApprovalConfig] = useState<ApprovalConfig | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { caseUnitLabel, otherUnitLabel, packUnitLabel, currency, claimTypes, claimSubTypes, batchIdConfiguration, displayOtherUnitName, enableFocPurchaseReturnClaims } = ConfigDictionary;
  const path = getLastNPathSegments(window.location.href, 2);
  const currentDesignation = JSON.parse(localStorage.authContext)?.user?.designation[0];
  const currentUserId = JSON.parse(localStorage.authContext)?.user?.loginId;
  const secondLastSegment=path[1];
  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);
  const onCustomAccordionToggle = (isExpanded: boolean) => {
    setIsScrolling(!isExpanded);
  }

  const filterData = (searchedValue: string) => {
    setSearchValue(searchedValue); 
    if (!searchedValue) {
      setFilteredRows(openClaimsRows); 
      return;
    }
    searchedValue = searchedValue.toLowerCase().replace(/\s/g, "");
    const finalData = data.filter((eachRow: any) => {
      const allValues = Object.values(eachRow);
      return allValues.some((eachValue: any) => {
        if (typeof eachValue === "string") {
          const formattedValue = eachValue.toLowerCase().replace(/\s/g, "");
          return formattedValue.includes(searchedValue);
        }
        return false;
      });
    });
    const sortedData = sortRows(
      finalData,
      accordionData.claimType,
      accordionData.typeOfExpense
    );
    setFilteredRows(sortedData);
  };

  useEffect(() => {
    setSearchValue(""); 
    setFilteredRows(openClaimsRows);
  }, [openClaimsRows]);

  const getTotalApprovedAmount = () => {
    let totalApproved = 0;
    openClaimsRows?.forEach((row: any) => {
      const amountStr = row.approvedClaimAmount?.replace(/[^0-9.]/g, '') || '0';
      totalApproved += parseFloat(amountStr);
    });
    return totalApproved;
  };

  const toTitleCase = (str: string) => str.replace(/\w\S*/g, (txt) => capitalize(txt.toLowerCase()));

  const formatClaimSubType = (subType: string): string => {
    if (subType.toLowerCase() === "asset") {
      return claimSubTypes[5];
    }
    if (subType.toLowerCase() === "banner") {
      return claimSubTypes[4];
    }
    if (subType.toLowerCase() === "allexcltov") {
      return claimSubTypes[2]
    }
    if (subType.toLowerCase() === "totalordervalue") {
      return claimSubTypes[3]
    }

    return subType
      .replace(/(RETURN|RETURNS)/gi, " Return")
      .split(" ")
      .map(toTitleCase)
      .join(" ");
  };

  const formatClaimType = (type: string): string => {
    if (type.toLowerCase() === claimTypes[2].toLowerCase().replace(" ", "")) {
      return claimTypes[2];
    }
    if (type.toLowerCase() === claimTypes[0].toLowerCase().replace(" ", "")) {
      return claimTypes[0];
    }
    if (type.toLowerCase() === claimTypes[1].toLowerCase().replace(" ", "")) {
      return claimTypes[1];
    }
    return toTitleCase(type);
  };

  const sortRows = (rows: any[], claimType: string, claimSubType: string) => {
    const sortedRows = [...rows];
    const formattedClaimType = formatClaimType(claimType);
    const formattedSubType = formatClaimSubType(claimSubType);
    if (formattedClaimType === claimTypes[2]) {
      return sortedRows.sort((a, b) =>
        (a.outletCode || '').localeCompare(b.outletCode || '')
      );
    }

    if (formattedClaimType === claimTypes[0] || formattedSubType === claimSubTypes[2]) {
      return sortedRows.sort((a, b) =>
        (a.skuCode || '').localeCompare(b.skuCode || '')
      );
    }

    if (formattedSubType === claimSubTypes[3]) {
      return sortedRows.sort((a, b) =>
        (a.invoiceNumber || '').localeCompare(b.invoiceNumber || '')
      );
    }
    return sortedRows;
  };

  const getActionButtons = async () => {
    try {
      const stages = await getConfigData(
        "dms_configuration",
        "claimStages"
      );
      const openClaimsOthersUIConfig = await getConfigData(
        "dms_configuration",
        "openClaimsOthersUIConfig"
      );
      
      setActionButtons(stages[0]?.configValue ?? []);
      setOpenClaimsOthersUIConfig(openClaimsOthersUIConfig[0]?.configValue ?? {});
    } catch (error) {
      console.error(error);
    }
  };

  const areAllRejected = (row: any) => {
    const isRejectedByOthers = (approvals: any[]) => 
      approvals?.some((approval: any) => 
        approval.status === 'REJECTED' && 
        approval.designation !== currentDesignation
      );
  
    if (row.batchIds && row.batchIds.length > 0) {
      return row.batchIds.every((batch: any) => isRejectedByOthers(batch.approvals || []));
    }
  
    if (row.invoices && row.invoices.length > 0) {
      return row.invoices.every((invoice: any) => isRejectedByOthers(invoice.approvals || []));
    }

    if (row.approvals && accordionData.typeOfExpense === claimSubTypes[3]) {
      return isRejectedByOthers(row.approvals || []);
    }
  
    return false;
  };

  const handleSetCheckedIdArray = (ids: any[]) => {
    const validIds = ids.filter((id) => {
      const row = openClaimsRows.find((row: any) => row.id === id);
      if (saleReturnsClaimIdsCheckboxHidden.includes(id)) {
        return false;
      }
      return row;
    });
    dispatch(setSaleReturnsCheckedClaimIds(validIds));
  };

  const processApprovalConfig = (configResponse: any[], approvalResponse: any[]): ApprovalConfig | null => {
    const claimApprovalConfig = configResponse.find(config => 
      config.hasOwnProperty('CLAIM_APPROVAL')
    )?.CLAIM_APPROVAL;
  
    if (!claimApprovalConfig || !claimApprovalConfig.workflow) {
      return null;
    }
  
    const transformedConfig: ApprovalConfig = {
      flow: claimApprovalConfig.workflow.map((level: any) => 
        level.approvers.map((approver: any) => approver.designation)
      ),
      currentLevel: undefined,
      lowestLevel: undefined
    };
  
    let lowestLevel = Infinity;
    approvalResponse.forEach((approval: any) => {
      if (approval.currentLevel !== undefined && approval.currentLevel < lowestLevel) {
        lowestLevel = approval.currentLevel;
      }
    });
  
    transformedConfig.lowestLevel = lowestLevel === Infinity ? 0 : lowestLevel;
  
    for (let i = transformedConfig.lowestLevel; i < transformedConfig.flow.length; i++) {
      if (transformedConfig.flow[i].includes(currentDesignation)) {
        transformedConfig.currentLevel = i;
        break;
      }
    }
  
    return transformedConfig;
  };

  const canUserTakeAction = (
    approvalData: any[],
    approvalConfig : ApprovalConfig | null
  ) => {
    if (!approvalConfig || approvalConfig.currentLevel === undefined) {
      return false;
    }
  
    const currentLevel = approvalConfig.currentLevel;
    const currentLevelDesignations = approvalConfig.flow[currentLevel];
  
    const currentLevelPendingApprovals = approvalData.filter(approval =>
      currentLevelDesignations.includes(approval.designation) &&
      approval.status === 'PENDING'
    );
  
    if (currentLevelPendingApprovals.length === 0) {
      return false;
    }
  
    if (currentLevel > (approvalConfig.lowestLevel || 0)) {
      const lowerLevelDesignations = approvalConfig.flow[currentLevel - 1];
      const lowerLevelApprovals = approvalData.filter(approval =>
        lowerLevelDesignations.includes(approval.designation)
      );

      if (lowerLevelApprovals.length > 0) {
        const allLowerLevelActed = lowerLevelApprovals.every(
          approval => approval.status !== 'PENDING'
        );

        if (!allLowerLevelActed) {
          return false;
        }
      }
    }
  
    return true;
  };
  
  const getAllDataForClaim = async (claimId: string) => {
    try {
      const [claimDetailsResponse, claimApprovalResponse, 
        configResponse
      ] = await Promise.all([
        getClaimDetails(claimId),
        getClaimApprovalDetails(claimId),
        getMetaData("NewApprovalFlow","RequestConfig")
      ]);
      const claimData = claimDetailsResponse.data.features?.[0];  
      
      const approvalData = transformApprovalData(claimApprovalResponse.data.features);

    const processedConfig = processApprovalConfig(configResponse, claimApprovalResponse.data.features);
      setApprovalConfig(processedConfig);

      const canAct = canUserTakeAction(approvalData, processedConfig);
      setCanApproveReject(canAct);

      if (claimData) {
        const {
          creationTime,
          supplier,
          supplierName,
          claimType,
          claimSubType,
          claimTotalValue,
          claimApprovedValue,
          claimTotalQuantity,
          claimDetails,
          status,
        } = claimData;

        const approvalMap = new Map<string, any[]>();
        approvalData.forEach((approval: any) => {
          if (!approvalMap.has(approval.claimDetailsId)) {
            approvalMap.set(approval.claimDetailsId, []);
          }
          approvalMap.get(approval.claimDetailsId)!.push(approval);
        });

        const updatedClaimDetails = claimDetails.map((detail: any) => ({
          ...detail,
          approvals: approvalMap.get(detail.id) || [],
        }));

        const claimDate = dayjs(creationTime).format("DD-MM-YYYY");
        const blobUrlMap: Record<string, string | null> = {};
        await Promise.all(
          updatedClaimDetails.map(async (detail: any) => {
            if (!blobUrlMap[detail.skuCode]) {
              blobUrlMap[detail.skuCode] = await getBlobUrlForSku(detail.skuCode);
            }
          })
        );

        let noOfSkus = 0;

        if (formatClaimSubType(claimSubType) === claimSubTypes[3] || formatClaimSubType(claimSubType) === claimSubTypes[4]) {
          noOfSkus = updatedClaimDetails.length;
        } else {
          const uniqueSkus = new Set<string>();
          updatedClaimDetails.forEach((detail: any) => {
            if (detail.skuCode) {
              uniqueSkus.add(detail.skuCode);
            }
          });
          noOfSkus = uniqueSkus.size;
        }
        
        const claimQty =
        claimType === claimTypes[2].toUpperCase()
          ? { cases: 0, pieces: 0, others: 0 }
          : (() => {
              const [cases = 0, pieces = 0, others = 0] = claimTotalQuantity
                .split(".")
                .map(Number);
              return { cases, pieces, others };
            })();      

        const assetQty =
          claimType === claimTypes[2].toUpperCase()
            ? updatedClaimDetails.reduce((acc: number, detail: any) => {
              return acc + (detail.assetQty ? Number(detail.assetQty) : 0);
            }, 0)
            : 0;

        const approvedQty = updatedClaimDetails.reduce(
          (acc: { cases: number; pieces: number; others: number }, detail: any) => {
            if (claimType === claimTypes[2].toUpperCase()) {
              const totalApproved = Number(detail.approvedQty) || 0;
              acc.cases += totalApproved;
              acc.pieces = 0;
              acc.others = 0;
            } else {
              const qtys = detail.approvedQty.split(".").map((val: any) => {
                const num = Number(val);
                return isNaN(num) ? 0 : num;
              });

              const [cases, pieces, others] = qtys.length === 3 ? qtys : [0, 0, 0];

              acc.cases += cases || 0;
              acc.pieces += pieces || 0;
              acc.others += others || 0;
            }

            return acc;
          },
          { cases: 0, pieces: 0, others: 0 }
        );

        const formattedStatus = status.includes("_") ? status.split("_").join(" ") : status;

        const formatQuantities = (cases: number, others: number, pieces: number) =>
          [
            caseUnitLabel && `${cases} ${caseUnitLabel}`,
            otherUnitLabel && `${others} ${otherUnitLabel}`,
            packUnitLabel && `${pieces} ${packUnitLabel}`
          ].filter(Boolean).join(", ");

        const totalQuantities = formatQuantities(claimQty.cases, claimQty.others, claimQty.pieces);
        const approvedTotalQuantities = formatQuantities(approvedQty.cases, approvedQty.others, approvedQty.pieces);

        const responseAccordion = {
          claimDate,
          distributorId: supplier ?? "-",
          distributorName: supplierName ?? "-",
          claimType: formatClaimType(claimType),
          typeOfExpense: formatClaimSubType(claimSubType),
          noOfSkus,
          assetQty,
          assetApprovedQty: claimType === claimTypes[2].toUpperCase() ? approvedQty.cases : 0,
          totalQuantities,
          approvedTotalQuantities,
          claimAmount: `${currency} ${formatDecimal(claimTotalValue)}`,
          approvedClaimAmount: `${currency} ${formatDecimal(claimApprovedValue)}`,
          status: formattedStatus
        };

        let products: Record<string, any> = {};
        if (displayOtherUnitName) {
          const dbResult = await getDataFromLocalDb("Product");
          products = dbResult?.data?.[0]?.data ?? {};
        }
        let customOtherUnitLabel = otherUnitLabel;

        let responseArray;
        if (formatClaimSubType(claimSubType) === claimSubTypes[0]) {          
          const groupedBySkuAndReference = updatedClaimDetails.reduce((acc: any, detail: any) => {
            const skuCode = detail.skuCode;
            const referenceNumber = detail.referenceNumber;
            const key = `${skuCode}-${referenceNumber}`;
            const imgBlobUrl = blobUrlMap[skuCode];
            if (displayOtherUnitName) {
              const product = products[skuCode];
              if (product?.otherUnitName && product.otherUnitName.length > 0) {
                customOtherUnitLabel = product.otherUnitName;
              }
            }
            if (!acc[key]) {
              acc[key] = {
                skuCode,
                skuName: detail.skuName,
                displayStartDate: detail.displayStartDate,
                returnOrderNo: referenceNumber,
                ptdCs: detail.extendedAttributes.ptdCs,
                ptdPc: detail.extendedAttributes.ptdPc,
                ptdOther: detail.extendedAttributes.ptdOther,
                batchCode: detail.extendedAttributes.batchCode,
                batchIds: [],
                damageCase: 0,
                damagePcs: 0,
                damageOthers: 0,
                approvedCase: 0,
                approvedPcs: 0,
                approvedOthers: 0,
                claimAmount: 0,
                approvedClaimAmount: 0,
                imgBlobUrl,
                otherUnitName: customOtherUnitLabel
              };
            }
            const [damageCases, damagePcs, damageOthers] = detail.claimedQty.split(".").map(Number);
            const [approvedCases, approvedPcs, approvedOthers] = detail.approvedQty.split(".").map(Number);
            acc[key].damageCase += damageCases || 0;
            acc[key].damagePcs += damagePcs || 0;
            acc[key].damageOthers += damageOthers || 0;
            acc[key].approvedCase += approvedCases || 0;
            acc[key].approvedPcs += approvedPcs || 0;
            acc[key].approvedOthers += approvedOthers || 0;
            acc[key].claimAmount += detail.claimedAmount || 0;
            acc[key].approvedClaimAmount += detail.approvedAmount || 0;

            let batch = acc[key].batchIds.find((b: any) => b.batchId === detail.batchCode);
            if (!batch) {
              batch = {
                batchId: detail.batchCode,
                claimableCs: 0,
                claimablePc: 0,
                claimableOther: 0,
                approvedCs: 0,
                approvedPc: 0,
                approvedOther: 0,
                claimAmount: 0,
                returnReasonArray: [],
                claimsApprovedAmount: 0,
                claimsRejectionReason: detail.rejectionReason,
                claimDetailsIds: [],
                approvals: [],
              };
              acc[key].batchIds.push(batch);
            }

            batch.returnReasonArray.push({
              cs: damageCases || 0,
              pc: damagePcs || 0,
              other: damageOthers || 0,
              approvedCs: approvedCases || 0,
              approvedPc: approvedPcs || 0,
              approvedOther: approvedOthers || 0,
              reason: detail.remark,
              claimDetailsId: detail.id,
              approvals: detail.approvals
            });

            batch.claimableCs += damageCases || 0;
            batch.claimablePc += damagePcs || 0;
            batch.claimableOther += damageOthers || 0;
            batch.approvedCs += approvedCases || 0;
            batch.approvedPc += approvedPcs || 0;
            batch.approvedOther += approvedOthers || 0;
            batch.claimsApprovedAmount += detail.approvedAmount || 0;
            batch.claimDetailsIds.push(detail.id);
            batch.approvals.push(...detail.approvals); 
            const { ptdCs, ptdPc, ptdOther } = acc[key];
            batch.claimAmount =
              batch.claimableCs * ptdCs +
              batch.claimablePc * ptdPc +
              batch.claimableOther * ptdOther;                          
            return acc;
          }, {});

          responseArray = Object.values(groupedBySkuAndReference).map((item: any, index: number) => ({
            ...item,
            id: index + 1,
            claimAmount: `${currency} ${formatDecimal(item.claimAmount)}`,
            approvedClaimAmount: `${currency} ${formatDecimal(item.approvedClaimAmount)}`,
          }));
        } else if (formatClaimSubType(claimSubType) === claimSubTypes[1]) {
          const groupedBySkuCode = updatedClaimDetails.reduce((acc: any, detail: any) => {
            const skuCode = detail.skuCode;
            const stockType = enableFocPurchaseReturnClaims ? detail.extendedAttributes?.stockType : "";
            const key = `${skuCode}-${stockType}`;
            
            const imgBlobUrl = blobUrlMap[skuCode];
            if (displayOtherUnitName) {
              const product = products[skuCode];
              if (product?.otherUnitName && product.otherUnitName.length > 0) {
                customOtherUnitLabel = product.otherUnitName;
              }
            }
            const ptdValues = batchIdConfiguration
            ? {}
            : {
                ptdCs: detail.extendedAttributes.ptdCs,
                ptdPc: detail.extendedAttributes.ptdPc,
                ptdOther: detail.extendedAttributes.ptdOther,
              };
            if (!acc[key]) {
              acc[key] = {
                skuCode,
                skuName: detail.skuName,
                stockType: stockType,
                ...ptdValues,
                batchIds: [],
                damageCase: 0,
                damagePcs: 0,
                damageOthers: 0,
                approvedCase: 0,
                approvedPcs: 0,
                approvedOthers: 0,
                claimAmount: 0,
                approvedClaimAmount: 0,
                imgBlobUrl,
                otherUnitName: customOtherUnitLabel
              };
            }

            const [damageCases, damagePcs, damageOthers] = detail.claimedQty.split(".").map(Number);
            const [approvedCases, approvedPcs, approvedOthers] = detail.approvedQty.split(".").map(Number);
            acc[key].damageCase += damageCases || 0;
            acc[key].damagePcs += damagePcs || 0;
            acc[key].damageOthers += damageOthers || 0;
            acc[key].approvedCase += approvedCases || 0;
            acc[key].approvedPcs += approvedPcs || 0;
            acc[key].approvedOthers += approvedOthers || 0;
            acc[key].claimAmount += detail.claimedAmount || 0;
            acc[key].approvedClaimAmount += detail.approvedAmount || 0;

            let batch = acc[key].batchIds.find((b: any) => b.batchId === detail.batchCode);
            if (!batch) {
              const ptdValues = batchIdConfiguration ?
                {
                  ptdCs: detail.extendedAttributes.ptdCs,
                  ptdPc: detail.extendedAttributes.ptdPc,
                  ptdOther: detail.extendedAttributes.ptdOther,
                } : {};
              batch = {
                batchId: detail.batchCode,
                claimableCs: 0,
                claimablePc: 0,
                claimableOther: 0,
                approvedCs: 0,
                approvedPc: 0,
                approvedOther: 0,
                claimAmount: 0,
                returnReasonArray: [],
                claimsApprovedAmount: 0,
                claimsRejectionReason: detail.rejectionReason,
                claimDetailsIds: [],
                approvals: [],
                ...ptdValues
              };
              acc[key].batchIds.push(batch);
            }

            batch.returnReasonArray.push({
              cs: damageCases || 0,
              pc: damagePcs || 0,
              other: damageOthers || 0,
              approvedCs: approvedCases || 0,
              approvedPc: approvedPcs || 0,
              approvedOther: approvedOthers || 0,
              reason: detail.remark,
              claimDetailsId: detail.id,
              approvals: detail.approvals
            });

            batch.claimableCs += damageCases || 0;
            batch.claimablePc += damagePcs || 0;
            batch.claimableOther += damageOthers || 0;
            batch.approvedCs += approvedCases || 0;
            batch.approvedPc += approvedPcs || 0;
            batch.approvedOther += approvedOthers || 0;
            batch.claimsApprovedAmount += detail.approvedAmount || 0;
            batch.claimDetailsIds.push(detail.id);
            batch.approvals.push(...detail.approvals); 
            const { ptdCs, ptdPc, ptdOther } = acc[key];
            if (batchIdConfiguration) {
              batch.claimAmount =
                batch.claimableCs * (batch.ptdCs || 0) +
                batch.claimablePc * (batch.ptdPc || 0) +
                batch.claimableOther * (batch.ptdOther || 0);
            } else {
            batch.claimAmount =
              batch.claimableCs * ptdCs +
              batch.claimablePc * ptdPc +
              batch.claimableOther * ptdOther;  
            }
            return acc;
          }, {});

          responseArray = Object.values(groupedBySkuCode).map((item: any, index: number) => ({
            ...item,
            id: index + 1,
            claimAmount: `${currency} ${formatDecimal(item.claimAmount)}`,
            approvedClaimAmount: `${currency} ${formatDecimal(item.approvedClaimAmount)}`,
          }));
        } 
        else if (formatClaimSubType(claimSubType) === claimSubTypes[2]) {
          const groupedBySkuAndRemark = updatedClaimDetails.reduce((acc: any, detail: any) => {
            const skuCode = detail.skuCode;
            const remark = detail.remark;
            const key = `${skuCode}-${remark}`;
            const imgBlobUrl = blobUrlMap[skuCode];
            if (displayOtherUnitName) {
              const product = products[skuCode];
              if (product?.otherUnitName && product.otherUnitName.length > 0) {
                customOtherUnitLabel = product.otherUnitName;
              }
            }
            const batchId = batchIdConfiguration ? detail.batchCode : '';
            if (!acc[key]) {
              acc[key] = {
                skuCode,
                skuName: detail.skuName,
                displayStartDate: detail.displayStartDate,
                invoices: [],
                damageCase: 0,
                damagePcs: 0,
                damageOthers: 0,
                approvedCase: 0,
                approvedPcs: 0,
                approvedOthers: 0,
                claimAmount: 0,
                approvedClaimAmount: 0,
                remark,
                imgBlobUrl,
                otherUnitName: customOtherUnitLabel
              };
            }        
            const [damageCases, damagePcs, damageOthers] = detail.claimedQty.split(".").map(Number);
            const [approvedCases, approvedPcs, approvedOthers] = detail.approvedQty.split(".").map(Number);
            
            acc[key].damageCase += damageCases || 0;
            acc[key].damagePcs += damagePcs || 0;
            acc[key].damageOthers += damageOthers || 0;
            acc[key].approvedCase += approvedCases || 0;
            acc[key].approvedPcs += approvedPcs || 0;
            acc[key].approvedOthers += approvedOthers || 0;
            acc[key].claimAmount += detail.claimedAmount || 0;
            acc[key].approvedClaimAmount += detail.approvedAmount || 0;
        
            const invoiceEntry = {
              id: `${skuCode}-${detail.referenceNumber}-${remark}${batchIdConfiguration ? `-${batchId}` : ''}`,
              invoiceNumber: detail.referenceNumber,
              outletName: detail.outletName || "-",
              outletCode: detail.outletCode || "-",
              cases: damageCases || 0,
              pieces: damagePcs || 0,
              others: damageOthers || 0,
              approvedCs: approvedCases || 0,
              approvedPc: approvedPcs || 0,
              approvedOther: approvedOthers || 0,
              discount: detail.claimedAmount || 0,
              claimsApprovedAmount: detail.approvedAmount || 0,
              claimsRejectionReason: detail.rejectionReason,
              totalAmount: detail.extendedAttributes.totalAmount,
              claimDetailsId: detail.id,
              approvals: detail.approvals,
              batchIds: batchId
            };
            acc[key].invoices.push(invoiceEntry);
            return acc;
          }, {});
        
          responseArray = Object.values(groupedBySkuAndRemark).map((item: any, index: number) => ({
            ...item,
            id: index + 1,
            claimAmount: `${currency} ${formatDecimal(item.claimAmount)}`,
            approvedClaimAmount: `${currency} ${formatDecimal(item.approvedClaimAmount)}`,
          }));
        }
        else if(formatClaimSubType(claimSubType) === claimSubTypes[3]){
          responseArray = updatedClaimDetails.map((detail: any, index: number) => {
            const [damageCases, damagePcs, damageOthers] = detail.claimedQty.split(".").map(Number); 
            const [approvedCases, approvedPcs, approvedOthers] = detail.approvedQty.split(".").map(Number); 
            
            const claimAmountNum = detail.claimedAmount;
            const approvedAmountNum = detail.approvedAmount;
            
            let status = '';
            if (secondLastSegment === 'closed') {
              if (approvedAmountNum === claimAmountNum) {
                status = 'APPROVED';
              } else if (approvedAmountNum === 0) {
                status = 'REJECTED';
              } else {
                status = 'PARTIALLY_APPROVED';
              }
            }
            
            return {
              id: index + 1,
              damageCases,
              damagePcs,
              damageOthers,
              approvedCases,
              approvedPcs,
              approvedOthers,
              displayStartDate: detail.displayStartDate || "-",
              displayEndDate: detail.displayEndDate || "-",
              invoiceNumber: detail.referenceNumber || "-",
              invoiceDateTime: detail.extendedAttributes.invoiceDateTime,
              claimAmount: `${currency} ${formatDecimal(detail.claimedAmount)}`,
              approvedClaimAmount: `${currency} ${formatDecimal(detail.approvedAmount)}`,
              claimsRejectionReason: detail.rejectionReason,
              claimDetailsId: detail.id,
              approvals: detail.approvals,
              ...(secondLastSegment === 'closed' && { status })
            };
          });
        }
        else if(formatClaimSubType(claimSubType) === claimSubTypes[4]){
          responseArray = updatedClaimDetails.map((detail: any, index: number) => {
            const skus = detail.extendedAttributes?.skus || [];
            const formattedSkus = skus.map((sku: any) => `${sku.skuCode} - ${sku.skuName}`);

            return {
              id: index + 1,
              outletCode: detail.outletCode || "-",
              outletName: detail.outletName || "-",
              skus: formattedSkus,
              installationCost: detail.installationCost,
              displayCost: detail.displayCost,
              assetName: detail.assetName,
              assetApprovedQty: Number(detail.approvedQty) || 0,
              displayStartDate: detail.displayStartDate || "-",
              displayEndDate: detail.displayEndDate || "-",
              returnOrderNo: detail.referenceNumber || "-",
              batchCode: detail.batchCode || "-",
              claimAmount: `${currency} ${formatDecimal(detail.claimedAmount)}`,
              approvedClaimAmount: `${currency} ${formatDecimal(detail.approvedAmount)}`,
              remark: detail.remark,
              blobUrl: detail.blobUrl,
              claimsRejectionReason: detail.rejectionReason
            };
          });
        }
        else {
          responseArray = updatedClaimDetails.map((detail: any, index: number) => {

            return {
              id: index + 1,
              outletCode: detail.outletCode || "-",
              outletName: detail.outletName || "-",
              assetType: detail.assetType || "-",
              assetId: detail.assetId || "-",
              assetQty: detail.assetQty || 0,
              assetApprovedQty: Number(detail.approvedQty) || 0,
              displayStartDate: detail.displayStartDate || "-",
              returnOrderNo: detail.referenceNumber || "-",
              batchCode: detail.batchCode || "-",
              claimAmount: `${currency} ${formatDecimal(detail.claimedAmount)}`,
              approvedClaimAmount: `${currency} ${formatDecimal(detail.approvedAmount)}`,
              remark: detail.remark,
              blobUrl: detail.blobUrl,
              claimsRejectionReason: detail.rejectionReason,
            };
          });
        }
        responseArray = sortRows(
          responseArray,
          claimData.claimType,
          claimData.claimSubType,
        );

        setAccordionData(responseAccordion);
        setData(responseArray);
        dispatch(setOpenClaimsRow(responseArray));
        dispatch(setSelectedOpenClaimsRow(responseArray[0]));
        const nonSelectableRows = !canAct
          ? responseArray.map((row: any) => row.id)
          : responseArray
            .filter((row: any) => areAllRejected(row))
            .map((row: any) => row.id);
        dispatch(setSaleReturnsClaimIdsCheckboxHidden(nonSelectableRows));

        if (formatClaimSubType(claimSubType) !== claimSubTypes[3]) { setIsModalOpen(true); }
      } else {
        throw new Error("No claim data found");
      }
    } catch (error) {
      setData([]);
      openPopup("Something went wrong", "Error");
    }
  };

  const claimsDetailsColumnsMetaData = getClaimsDetailsColumnsMetaData(accordionData?.claimType, accordionData?.typeOfExpense, claimTypes, claimSubTypes, secondLastSegment, enableFocPurchaseReturnClaims );

  const createPostBody = (openClaimsRows: any) => {
    const requestDetails: any[] = [];
    let allRejected = true; 
    let allApproved = true;
    let hasItems = false;
    let requestId: string | undefined;
    const stockSkuDetails: Record<string, any> = {};
  
    const isHighestLevel =
      approvalConfig?.flow && typeof approvalConfig.currentLevel === "number"
        ? approvalConfig.currentLevel === approvalConfig.flow.length - 1
        : false;
    const isPurchaseReturns = accordionData.typeOfExpense === claimSubTypes[1];
    const shouldIncludeStockType = isPurchaseReturns && enableFocPurchaseReturnClaims;

    openClaimsRows.forEach((row: any) => {
      if (row.batchIds && row.batchIds.length > 0) {
        row.batchIds.forEach((batch: any) => {
          const batchApproved = batch.status === "APPROVED";
          
          batch.returnReasonArray?.forEach((reason: any) => {
            const pendingApproval = reason.approvals?.find((approval: any) =>
              approval.status === 'PENDING' &&
              approval.userId.toLowerCase() === currentUserId.toLowerCase() &&
              approval.designation.toLowerCase() === currentDesignation.toLowerCase()
            );
  
            if (pendingApproval) {
              if (!requestId && pendingApproval.requestId) {
                requestId = pendingApproval.requestId;
              }
              hasItems = true;
              
              const requestedValue = `${reason.cs}.${reason.pc}.${reason.other}`;
              const approvedValue = `${reason.approvedCs}.${reason.approvedPc}.${reason.approvedOther}`;
              const approvedAmount = 
              (reason.approvedCs || 0) * (batchIdConfiguration && batch.ptdCs ? batch.ptdCs : row.ptdCs || 0) +
              (reason.approvedPc || 0) * (batchIdConfiguration && batch.ptdPc ? batch.ptdPc : row.ptdPc || 0) +
              (reason.approvedOther || 0) * (batchIdConfiguration && batch.ptdOther ? batch.ptdOther : row.ptdOther || 0);
  
              if (batchApproved) {
                allRejected = false; 
              }
              else {
                allApproved = false;
              }
  
              requestDetails.push({
                referenceId: reason.claimDetailsId,
                requestedValue,
                approvedValue,
                status: batchApproved ? "APPROVED" : "REJECTED",
                remarks: batchApproved ? "" : (batch.rejectionReason || "Rejected"),
                meta: {
                  approvedAmount
                }
              });
  
              if (isHighestLevel && accordionData.claimType === claimTypes[0] && batchApproved && 
                  (reason.approvedCs > 0 || reason.approvedPc > 0 || reason.approvedOther > 0)) {
                const key = shouldIncludeStockType ? `${row.skuCode}-${batch.batchId}-${reason.reason}-${row.stockType}` : `${row.skuCode}-${batch.batchId}-${reason.reason}`;
                
                if (!stockSkuDetails[key]) {
                  stockSkuDetails[key] = {
                    skuCode: accordionData.typeOfExpense === claimSubTypes[0] ? row.batchCode : row.skuCode,
                    batchId: batch.batchId,
                    caseQty: reason.approvedCs,
                    pieceQty: reason.approvedPc,
                    otherQty: reason.approvedOther,
                    reason: reason.reason || "claim_approval",
                    type: "normal"
                  };
                  if (shouldIncludeStockType) {
                    stockSkuDetails[key].type = row.stockType || "normal";
                  }
                } else {
                  stockSkuDetails[key].caseQty += reason.approvedCs;
                  stockSkuDetails[key].pieceQty += reason.approvedPc;
                  stockSkuDetails[key].otherQty += reason.approvedOther;
                }
              }
            }
          });
        });
      }
      if (row.invoices && row.invoices.length > 0) {
        row.invoices.forEach((invoice: any) => {
          const invoiceApproved = invoice.status === "APPROVED";
          
          const pendingApproval = invoice.approvals?.find((approval: any) => 
            approval.status === 'PENDING' && 
            approval.userId.toLowerCase() === currentUserId.toLowerCase() && 
            approval.designation.toLowerCase() === currentDesignation.toLowerCase()
          );

          if (pendingApproval) {
            if (!requestId && pendingApproval.requestId) {
              requestId = pendingApproval.requestId;
            }
            hasItems = true;
            
            if (invoiceApproved) {
              allRejected = false;
            }
            else {
              allApproved = false;
            }
  
            const requestedValue = `${invoice.cases}.${invoice.pieces}.${invoice.others}`;
            const approvedValue = `${invoice.approvedCs}.${invoice.approvedPc}.${invoice.approvedOther}`;
  
            requestDetails.push({
              referenceId: invoice.claimDetailsId,
              requestedValue,
              approvedValue,
              status: invoiceApproved ? "APPROVED" : "REJECTED",
              remarks: invoiceApproved ? "" : (invoice.rejectionReason || "Rejected"),
              meta: {
                approvedAmount: invoiceApproved ? invoice.discount : 0
              }
            });
          }
        });
      }
      if (accordionData.typeOfExpense === claimSubTypes[3]) {
        const invoiceApproved = row.status === "APPROVED";
  
        const pendingApproval = row.approvals?.find((approval: any) =>
          approval.status === 'PENDING' &&
          approval.userId.toLowerCase() === currentUserId.toLowerCase() &&
          approval.designation.toLowerCase() === currentDesignation.toLowerCase()
        );

        if (pendingApproval) {
          if (!requestId && pendingApproval.requestId) {
            requestId = pendingApproval.requestId;
          }
          hasItems = true;
          
          if (invoiceApproved) {
            allRejected = false;
          }
          else {
            allApproved = false;
          }
  
          const requestedValue = `${row.damageCases}.${row.damagePcs}.${row.damageOthers}`;
          const approvedValue = `${row.approvedCases}.${row.approvedPcs}.${row.approvedOthers}`;
          const approvedAmount = row.status === "APPROVED" ? 
            parseFloat(row.approvedClaimAmount.replace(/[^0-9.]/g, '')) : 0;
  
          requestDetails.push({
            referenceId: row.claimDetailsId,
            requestedValue,
            approvedValue,
            status: invoiceApproved ? "APPROVED" : "REJECTED",
            remarks: invoiceApproved ? "" : (row.rejectionReason || "Rejected"),
            meta: {
              approvedAmount
            }
          });
        }
      }
    });
  
    const status = hasItems && allRejected ? "REJECTED" : "APPROVED";
    let newStatus;
    if (!hasItems) {
      newStatus = "";
    } else if (allRejected) {
      newStatus = "REJECTED";
    } else if (allApproved) {
      newStatus = "APPROVED";
    } else {
      newStatus = "PARTIALLY_APPROVED";
    }
    const postBody = {
      referenceNumber: claimId,
      status,
      requestDetails
    };
  
    const claimedStockBody = isHighestLevel && accordionData.claimType === claimTypes[0] && Object.keys(stockSkuDetails).length > 0 ? {
      type: accordionData.typeOfExpense === claimSubTypes[0] ? "sale" : "purchase",
      supplier: accordionData.distributorId,
      skuDetails: Object.values(stockSkuDetails)
    } : null;
  
    return { postBody, requestId, claimedStockBody, newStatus };
  };
  
  const init = async () => {
    if (!claimId) {
      return;
    }
    setLoader(true);
    try {
      await Promise.allSettled([
        getAllDataForClaim(claimId),
        getActionButtons()
      ]);
    } finally {
      setLoader(false);
    }
  };

  const updateSelectedRowInRows = (updatedRow: any) => {
    dispatch(setSelectedOpenClaimsRow(updatedRow));
        if (openClaimsRows) {
      const updatedRows = openClaimsRows.map((row:any) => 
        row.id === updatedRow.id ? updatedRow : row
      );
      dispatch(setOpenClaimsRow(updatedRows));
    }
  };

  const handleRowClick = (params: any) => {
    dispatch(setSelectedOpenClaimsRow(params.row));
    setIsModalOpen(true);
  };

  const handleOpenModal = (row: any) => {
    dispatch(setSelectedOpenClaimsRow(row));
    setIsStatusModalOpen(true);
};

  const handleCloseModal = () => {
    setIsStatusModalOpen(false);
    setSelectedOpenClaimsRow(null);        
  };

  useEffect(() => {
    logLoadTrace(init, "open_claims_details_page_load_time");
  }, [claimId]);

  useEffect(() => {
    return () => {
      if (!window.location.pathname.includes('details')) {
        dispatch(setSaleReturnsCheckedClaimIds([]));
        dispatch(setSaleReturnsClaimIdsCheckboxHidden([]));
        dispatch(setOpenClaimsRow([]));
        }
    };
  }, []);

  const ClaimFooter = () => {
    const dispatch = useDispatch();
    const hasSelectedRows = saleReturnsCheckedClaimIds.length > 0 &&
    saleReturnsCheckedClaimIds.some((id: string | number) => {
      const row = openClaimsRows.find((row: { id: string | number }) => row.id === id);
      return row ? !areAllRejected(row) : false;
    });
  
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const getPendingItemsCount = () => {
      return openClaimsRows.filter((row: any) => {
        if (areAllRejected(row)) {
          return false;
        }
        return !saleReturnsCheckedClaimIds.includes(row.id);
      }).length;
    };
    const handleApproveAll = async () => {
      try {
        setIsSubmitting(true);
        const pendingCount = getPendingItemsCount();

        const allSelectableRows = openClaimsRows.filter((row: any) => 
          !areAllRejected(row)
        );
        
        const allEnabledSelected = allSelectableRows.every((row: any) => 
          saleReturnsCheckedClaimIds.includes(row.id)
        );
        
        if (saleReturnsCheckedClaimIds.length === 0) {
          dispatch(setSaleReturnsCheckedClaimIds(allSelectableRows.map((row: any) => row.id)));
          setApproveModalType('full');
          setApprovalModalOpen(true);
        } 
        else if (allEnabledSelected) {
          setApproveModalType('full');
          setApprovalModalOpen(true);
        }
        else if (saleReturnsCheckedClaimIds.length === openClaimsRows.length) {
          setApproveModalType('full');
          setApprovalModalOpen(true);
        } 
        else {          
          setApproveModalType('partial');
          setPendingItemsCount(pendingCount);
          setApprovalModalOpen(true);
        }
      } catch (error) {
        console.error("Error approving", error);
        openPopup("Failed to approve", "Error");
      } finally {
        setIsSubmitting(false);
      }
    };
  
    const processApproval = async () => {
  
      const updatedRows = openClaimsRows.map((row: any) => {
  
        let approvedCase = row.approvedCase || 0;
        let approvedPcs = row.approvedPcs || 0;
        let approvedOthers = row.approvedOthers || 0;
        let approvedClaimAmount = parseFloat((row.approvedClaimAmount || '0').replace(/[^0-9.]/g, '')) || 0;
  
       if (row.batchIds) {
        const updatedBatchIds = row.batchIds?.map((batch: any) => {
          const lowerLevelRejection = batch.approvals?.find((approval: any) => {
            const approvalLevel = approvalConfig?.flow.findIndex(level => 
              level.includes(approval.designation)
            );
            return approval.status === 'REJECTED' && 
                   approvalLevel !== undefined && 
                   approvalLevel < (approvalConfig?.currentLevel ?? Infinity);
          });
  
          if (lowerLevelRejection) {
            return {
              ...batch,
              approvedCs: 0,
              approvedPc: 0,
              approvedOther: 0,
              returnReasonArray: batch.returnReasonArray?.map((reason: any) => ({
                ...reason,
                approvedCs: 0,
                approvedPc: 0,
                approvedOther: 0
              })),
              status: "REJECTED",
              rejectionReason: lowerLevelRejection.reason || "Rejected by lower level"
            };
          }
  
          if (!batch.status) {
            const isAlreadyApproved = batch.approvals?.some((a: any) => 
              a.status === 'APPROVED' && 
              a.designation !== currentDesignation
            );
            if (!isAlreadyApproved) {
              approvedCase += batch.claimableCs || 0;
              approvedPcs += batch.claimablePc || 0;
              approvedOthers += batch.claimableOther || 0;
              approvedClaimAmount += batch.claimAmount || 0;
            }
  
            return {
              ...batch,
              approvedCs: batch.claimableCs,
              approvedPc: batch.claimablePc,
              approvedOther: batch.claimableOther,
              returnReasonArray: batch.returnReasonArray?.map((reason: any) => ({
                ...reason,
                approvedCs: reason.cs,
                approvedPc: reason.pc,
                approvedOther: reason.other
              })),
              status: "APPROVED"
            };
          }
          return batch;
        });
  
        return {
          ...row,
          batchIds: updatedBatchIds,
          approvedCase,
          approvedPcs,
          approvedOthers,
          approvedClaimAmount: `${currency} ${formatDecimal(approvedClaimAmount)}`,
          status: updatedBatchIds.every((b: any) => b.status === "APPROVED") 
              ? "APPROVED" 
              : updatedBatchIds.every((b: any) => b.status === "REJECTED") 
              ? "REJECTED"
              : "PARTIALLY_APPROVED"
        };
      }
        
        if (row.invoices) {
          const updatedInvoices = row.invoices.map((invoice: any) => {
            const lowerLevelRejection = invoice.approvals?.find((approval: any) => {
              const approvalLevel = approvalConfig?.flow.findIndex(level => 
                level.includes(approval.designation)
              );
              return approval.status === 'REJECTED' && 
                     approvalLevel !== undefined && 
                     approvalLevel < (approvalConfig?.currentLevel ?? Infinity);
            });
    
            if (lowerLevelRejection) {
              return {
                ...invoice,
                approvedCs: 0,
                approvedPc: 0,
                approvedOther: 0,
                status: "REJECTED",
                rejectionReason: lowerLevelRejection.reason || "Rejected by lower level"
              };
            }
    
            if (!invoice.status) {
              const isAlreadyApproved = invoice.approvals?.some((a: any) => 
                a.status === 'APPROVED' && 
                a.designation !== currentDesignation
              );
              if (!isAlreadyApproved) {
                approvedCase += invoice.cases || 0;
                approvedPcs += invoice.pieces || 0;
                approvedOthers += invoice.others || 0;
                approvedClaimAmount += invoice.discount || 0;
              }
    
              return {
                ...invoice,
                approvedCs: invoice.cases,
                approvedPc: invoice.pieces,
                approvedOther: invoice.others,
                status: "APPROVED"
              };
            }
            return invoice;
          });
    
          return {
            ...row,
            invoices: updatedInvoices,
            approvedCase,
            approvedPcs,
            approvedOthers,
            approvedClaimAmount: `${currency} ${formatDecimal(approvedClaimAmount)}`,
            status: updatedInvoices.every((inv: any) => inv.status === "APPROVED") 
              ? "APPROVED" 
              : updatedInvoices.every((inv: any) => inv.status === "REJECTED") 
              ? "REJECTED"
              : "PARTIALLY_APPROVED"
          };
        }

        if (accordionData.typeOfExpense === claimSubTypes[3]) {
          const lowerLevelRejection = row.approvals?.find((approval: any) => {
            const approvalLevel = approvalConfig?.flow.findIndex(level => 
              level.includes(approval.designation)
            );
            return approval.status === 'REJECTED' && 
                   approvalLevel !== undefined && 
                   approvalLevel < (approvalConfig?.currentLevel ?? Infinity);
          });
    
          if (lowerLevelRejection) {
            return {
              ...row,
              approvedCases: 0,
              approvedPcs: 0,
              approvedOthers: 0,
              approvedClaimAmount: `${currency} 0.00`,
              status: "REJECTED",
              claimsRejectionReason: lowerLevelRejection.reason || "Rejected by lower level"
            };
          }
    
          if (!row.status) {
            const isAlreadyApproved = row.approvals?.some((a: any) => 
              a.status === 'APPROVED' && 
              a.designation !== currentDesignation
            );
            if (!isAlreadyApproved) {
              approvedClaimAmount = parseFloat(row.claimAmount.replace(/[^0-9.]/g, '')) || 0;
            }

            return {
              ...row,
              approvedCases: row.damageCases || 0,
              approvedPcs: row.damagePcs || 0,
              approvedOthers: row.damageOthers || 0,
              approvedClaimAmount: isAlreadyApproved ? row.approvedClaimAmount : `${currency} ${formatDecimal(approvedClaimAmount)}`,
              status: "APPROVED"
            };
          }
          return row;
        }

        if (accordionData.claimType === claimTypes[2]) {
          if (row.status === "APPROVED" || row.status === "REJECTED") {
            return row;
          }
        
          const claimAmount = parseFloat(row.claimAmount.replace(/[^\d.]/g, '')) || 0;
          return {
            ...row,
            approvedClaimAmount: `${currency} ${formatDecimal(claimAmount)}`,
            status: "APPROVED",
            ...(accordionData.typeOfExpense === claimSubTypes[5] && {
              assetApprovedQty: row.assetQty || 0
            })
          };
        }
      
        return row;
      });
      return updatedRows;
    };
    const handleRejectClick = () => {
      const allSelectableRows = openClaimsRows.filter((row: any) => 
        !areAllRejected(row)
      );
    
      const selectedRows = openClaimsRows.filter((row: any) => 
        saleReturnsCheckedClaimIds.includes(row.id) && !areAllRejected(row)
      );
    
      const allEnabledSelected = allSelectableRows.every((row: any) => 
        saleReturnsCheckedClaimIds.includes(row.id)
      );
    
      const allAlreadyRejected = selectedRows.every((row: any) => row.status === "REJECTED");
      
      if (allAlreadyRejected) {
        setApprovalModalState(1);
        setApprovalModalOpen(true);
        const pendingCount = getPendingItemsCount();

        if (pendingCount > 0) {
          setApproveModalType('rejectPartial');
          setPendingItemsCount(pendingCount);
        } else if (allEnabledSelected || saleReturnsCheckedClaimIds.length === openClaimsRows.length) {
          setApproveModalType('rejectFull');
        } else {
          setApproveModalType('rejectPartial');
        }
        return;
      }
    
      setShowRejectModal(true);
    };

      const processRejection = async (reasons: Record<string, string>) => {
        const updatedRows = openClaimsRows.map((row: any) => {
          let approvedCase = 0;
          let approvedPcs = 0;
          let approvedOthers = 0;
          let approvedClaimAmount = 0;
    
          if (saleReturnsCheckedClaimIds.includes(row.id)) {
            if (row.batchIds) {
              const updatedBatchIds = row.batchIds?.map((batch: any) => {
                const lowerLevelRejection = batch.approvals?.find((approval: any) => {
                  const approvalLevel = approvalConfig?.flow.findIndex(level => 
                    level.includes(approval.designation)
                  );
                  return approval.status === 'REJECTED' && 
                         approvalLevel !== undefined && 
                         approvalLevel < (approvalConfig?.currentLevel ?? Infinity);
                });
      
                if (lowerLevelRejection) {
                  return {
                    ...batch,
                    approvedCs: 0,
                    approvedPc: 0,
                    approvedOther: 0,
                    returnReasonArray: batch.returnReasonArray?.map((reason: any) => ({
                      ...reason,
                      approvedCs: 0,
                      approvedPc: 0,
                      approvedOther: 0
                    })),
                    status: "REJECTED",
                    rejectionReason: lowerLevelRejection.reason || "Rejected by lower level"
                  };
                }
      
                const reasonId = enableFocPurchaseReturnClaims && row.stockType
            ? `${batch.batchId}-${row.skuCode}-${row.returnOrderNo || ''}-${row.stockType}`
            : `${batch.batchId}-${row.skuCode}-${row.returnOrderNo || ''}`;
                if (batch.status !== "REJECTED") { 
                  return {
                    ...batch,
                    approvedCs: 0,
                    approvedPc: 0,
                    approvedOther: 0,
                    returnReasonArray: batch.returnReasonArray?.map((reason: any) => ({
                      ...reason,
                      approvedCs: 0,
                      approvedPc: 0,
                      approvedOther: 0
                    })),
                    status: "REJECTED",
                    rejectionReason: reasons[reasonId] || "Rejected"
                  };
                }
                return batch;
              });
      
              return {
                ...row,
                batchIds: updatedBatchIds,
                approvedCase,
                approvedPcs,
                approvedOthers,
                approvedClaimAmount: `${currency} ${formatDecimal(approvedClaimAmount)}`,
                status: updatedBatchIds.every((b: any) => b.status === "REJECTED") 
                  ? "REJECTED" 
                  : updatedBatchIds.every((b: any) => b.status === "APPROVED") 
                  ? "APPROVED"
                  : "PARTIALLY_APPROVED"
              };
            }
            if (row.invoices) {
              const updatedInvoices = row.invoices.map((invoice: any) => {
                const lowerLevelRejection = invoice.approvals?.find((approval: any) => {
                  const approvalLevel = approvalConfig?.flow.findIndex(level => 
                    level.includes(approval.designation)
                  );
                  return approval.status === 'REJECTED' && 
                         approvalLevel !== undefined && 
                         approvalLevel < (approvalConfig?.currentLevel ?? Infinity);
                });
      
                if (lowerLevelRejection) {
                  return {
                    ...invoice,
                    approvedCs: 0,
                    approvedPc: 0,
                    approvedOther: 0,
                    status: "REJECTED",
                    rejectionReason: lowerLevelRejection.reason || "Rejected by lower level"
                  };
                }
      
                const reasonId = batchIdConfiguration
                ? `${invoice.invoiceNumber}-${row.skuCode}-${row.remark || ''}-${invoice.batchIds}`
                : `${invoice.invoiceNumber}-${row.skuCode}-${row.remark || ''}`;
                if (!invoice.status || invoice.status !== "REJECTED") {
                  return {
                    ...invoice,
                    approvedCs: 0,
                    approvedPc: 0,
                    approvedOther: 0,
                    status: "REJECTED",
                    rejectionReason: reasons[reasonId] || "Rejected"
                  };
                }
                return invoice;
              });
      
              return {
                ...row,
                invoices: updatedInvoices,
                approvedCase,
                approvedPcs,
                approvedOthers,
                approvedClaimAmount: `${currency} ${formatDecimal(approvedClaimAmount)}`,
                status: updatedInvoices.every((inv: any) => inv.status === "REJECTED") 
                  ? "REJECTED" 
                  : updatedInvoices.every((inv: any) => inv.status === "APPROVED") 
                  ? "APPROVED"
                  : "PARTIALLY_APPROVED"
              };
            }
            if (accordionData.typeOfExpense === claimSubTypes[3]) {
              const lowerLevelRejection = row.approvals?.find((approval: any) => {
                const approvalLevel = approvalConfig?.flow.findIndex(level => 
                  level.includes(approval.designation)
                );
                return approval.status === 'REJECTED' && 
                       approvalLevel !== undefined && 
                       approvalLevel < (approvalConfig?.currentLevel ?? Infinity);
              });
      
              if (lowerLevelRejection) {
                return {
                  ...row,
                  approvedCases: 0,
                  approvedPcs: 0,
                  approvedOthers: 0,
                  approvedClaimAmount: `${currency} 0.00`,
                  status: "REJECTED",
                  rejectionReason: lowerLevelRejection.reason || "Rejected by lower level"
                };
              }
      
              return {
                ...row,
                approvedCases: 0,
                approvedPcs: 0,
                approvedOthers: 0,
                approvedClaimAmount: `${currency} 0.00`,
                status: "REJECTED",
                rejectionReason: reasons[row.id] || "Rejected"
              };
            }

            if (accordionData.claimType === claimTypes[2]) {
              if (row.status === "REJECTED") return row;
            
              return {
                ...row,
                approvedClaimAmount: `${currency} 0.00`,
                status: "REJECTED",
                rejectionReason: reasons[row.outletCode] || "Rejected",
                ...(accordionData.typeOfExpense === claimSubTypes[5] && { assetApprovedQty: 0 })
              };
            }
            
          } 
          else if (approveModalType === 'rejectPartial') {
            if (row.batchIds) {
              const updatedBatchIds = row.batchIds?.map((batch: any) => {
                const lowerLevelRejection = batch.approvals?.find((approval: any) => {
                  const approvalLevel = approvalConfig?.flow.findIndex(level => 
                    level.includes(approval.designation)
                  );
                  return approval.status === 'REJECTED' && 
                         approvalLevel !== undefined && 
                         approvalLevel < (approvalConfig?.currentLevel ?? Infinity);
                });
          
                if (lowerLevelRejection) {
                  return {
                    ...batch,
                    approvedCs: 0,
                    approvedPc: 0,
                    approvedOther: 0,
                    returnReasonArray: batch.returnReasonArray?.map((reason: any) => ({
                      ...reason,
                      approvedCs: 0,
                      approvedPc: 0,
                      approvedOther: 0
                    })),
                    status: "REJECTED",
                    rejectionReason: lowerLevelRejection.reason || "Rejected by lower level"
                  };
                }
          
                if (!saleReturnsCheckedClaimIds.includes(row.id)) {
                  approvedCase += batch.claimableCs || 0;
                  approvedPcs += batch.claimablePc || 0;
                  approvedOthers += batch.claimableOther || 0;
                  approvedClaimAmount += batch.claimAmount || 0;
          
                  return {
                    ...batch,
                    approvedCs: batch.claimableCs || 0,
                    approvedPc: batch.claimablePc || 0,
                    approvedOther: batch.claimableOther || 0,
                    returnReasonArray: batch.returnReasonArray?.map((reason: any) => ({
                      ...reason,
                      approvedCs: reason.cs || 0,
                      approvedPc: reason.pc || 0,
                      approvedOther: reason.other || 0
                    })),
                    status: "APPROVED",
                    rejectionReason: undefined
                  };
                }
                
                const reasonId = `${batch.batchId}-${row.skuCode}-${row.returnOrderNo}`;
                return {
                  ...batch,
                  approvedCs: 0,
                  approvedPc: 0,
                  approvedOther: 0,
                  returnReasonArray: batch.returnReasonArray?.map((reason: any) => ({
                    ...reason,
                    approvedCs: 0,
                    approvedPc: 0,
                    approvedOther: 0
                  })),
                  status: "REJECTED",
                  rejectionReason: reasons[reasonId] || "Rejected"
                };
              });
          
              return {
                ...row,
                batchIds: updatedBatchIds,
                approvedCase,
                approvedPcs,
                approvedOthers,
                approvedClaimAmount: `${currency} ${formatDecimal(approvedClaimAmount)}`,
                status: updatedBatchIds.every((b: any) => b.status === "APPROVED") 
                  ? "APPROVED" 
                  : updatedBatchIds.every((b: any) => b.status === "REJECTED") 
                  ? "REJECTED"
                  : "PARTIALLY_APPROVED"
              };
            }
    
            if (row.invoices) {
              const updatedInvoices = row.invoices.map((invoice: any) => {
                const lowerLevelRejection = invoice.approvals?.find((approval: any) => {
                  const approvalLevel = approvalConfig?.flow.findIndex(level => 
                    level.includes(approval.designation)
                  );
                  return approval.status === 'REJECTED' && 
                         approvalLevel !== undefined && 
                         approvalLevel < (approvalConfig?.currentLevel ?? Infinity);
                });
            
                if (lowerLevelRejection) {
                  return {
                    ...invoice,
                    approvedCs: 0,
                    approvedPc: 0,
                    approvedOther: 0,
                    status: "REJECTED",
                    rejectionReason: lowerLevelRejection.reason || "Rejected by lower level"
                  };
                }
            
                if (!saleReturnsCheckedClaimIds.includes(row.id)) {
                  approvedCase += invoice.cases || 0;
                  approvedPcs += invoice.pieces || 0;
                  approvedOthers += invoice.others || 0;
                  approvedClaimAmount += invoice.discount || 0;
            
                  return {
                    ...invoice,
                    approvedCs: invoice.cases || 0,
                    approvedPc: invoice.pieces || 0,
                    approvedOther: invoice.others || 0,
                    status: "APPROVED",
                    rejectionReason: undefined
                  };
                }
                
                const reasonId = batchIdConfiguration
                ? `${invoice.invoiceNumber}-${row.skuCode}-${row.remark || ''}-${invoice.batchIds}`
                : `${invoice.invoiceNumber}-${row.skuCode}-${row.remark || ''}`;
                return {
                  ...invoice,
                  approvedCs: 0,
                  approvedPc: 0,
                  approvedOther: 0,
                  status: "REJECTED",
                  rejectionReason: reasons[reasonId] || "Rejected"
                };
              });
            
              return {
                ...row,
                invoices: updatedInvoices,
                approvedCase,
                approvedPcs,
                approvedOthers,
                approvedClaimAmount: `${currency} ${formatDecimal(approvedClaimAmount)}`,
                status: updatedInvoices.every((inv: any) => inv.status === "APPROVED") 
                  ? "APPROVED" 
                  : updatedInvoices.every((inv: any) => inv.status === "REJECTED") 
                  ? "REJECTED"
                  : "PARTIALLY_APPROVED"
              };
            }
            if (accordionData.typeOfExpense === claimSubTypes[3]) {
              const lowerLevelRejection = row.approvals?.find((approval: any) => {
                const approvalLevel = approvalConfig?.flow.findIndex(level => 
                  level.includes(approval.designation)
                );
                return approval.status === 'REJECTED' && 
                       approvalLevel !== undefined && 
                       approvalLevel < (approvalConfig?.currentLevel ?? Infinity);
              });
      
              if (lowerLevelRejection) {
                return {
                  ...row,
                  approvedCases: 0,
                  approvedPcs: 0,
                  approvedOthers: 0,
                  approvedClaimAmount: `${currency} 0.00`,
                  status: "REJECTED",
                  rejectionReason: lowerLevelRejection.reason || "Rejected by lower level"
                };
              }
      
              if (!saleReturnsCheckedClaimIds.includes(row.id)) {
                return {
                  ...row,
                  approvedCases: row.damageCases || 0,
                  approvedPcs: row.damagePcs || 0,
                  approvedOthers: row.damageOthers || 0,
                  approvedClaimAmount: row.claimAmount || `${currency} 0.00`,
                  status: "APPROVED"
                };
              } else {
                return {
                  ...row,
                  approvedCases: 0,
                  approvedPcs: 0,
                  approvedOthers: 0,
                  approvedClaimAmount: `${currency} 0.00`,
                  status: "REJECTED",
                  rejectionReason: reasons[row.id] || "Rejected"
                };
              }
            }

            if (accordionData.claimType === claimTypes[2]) {
              return {
                ...row,
                approvedClaimAmount: row.claimAmount || `${currency} 0.00`,
                status: "APPROVED",
                ...(accordionData.typeOfExpense === claimSubTypes[5] && {
                  assetApprovedQty: row.assetQty || 0
                })
              };
            }
            
          }
          return row;
        });
    
        return updatedRows;
      };
      const getPostBodyWithRef = (updatedRows: any[]) => {
        const result = createPostBody(updatedRows);
        postBodyRef.current = result.postBody;
        return result;
      };
      const handleRejectWithReasons = async (reasons: Record<string, string>) => {
        const allSelectableRows = openClaimsRows.filter((row: any) => 
          !areAllRejected(row)
        );
      
        const allEnabledSelected = allSelectableRows.every((row: any) => 
          saleReturnsCheckedClaimIds.includes(row.id)
        );
      
        setRejectionReasons(reasons);
        setApprovalModalState(1);
        setApprovalModalOpen(true);
      
        const pendingCount = getPendingItemsCount();
      
        if (allEnabledSelected || saleReturnsCheckedClaimIds.length === openClaimsRows.length) {
          setApproveModalType('rejectFull');
        }
        else if (pendingCount > 0) {
          setApproveModalType('rejectPartial');
          setPendingItemsCount(pendingCount);
        }  
        else {
          setApproveModalType('rejectPartial');
        }
      };
    const handleRejectionSubmit = async () => {
      try {
        const updatedRows = await processRejection(rejectionReasons);
        return updatedRows;
      } catch (error) {
        console.error("Error in rejection flow:", error);
        throw error;
      }
    };
    const handleApprovalSubmit = async () => {
      try {
        const updatedRows = await processApproval();
        return updatedRows;
      } catch (error) {
        console.error("Approval failed:", error);
        return false;
      }
    };

    const getPendingItemLabel = () => {
      if (accordionData.claimType === claimTypes[1]) {
        return pendingItemsCount === 1 ? "invoice" : "invoices";
      }
      else if (accordionData.claimType === claimTypes[0]) {
        return pendingItemsCount === 1 ? "SKU" : "SKUs";
      }
      return pendingItemsCount === 1 ? "outlet" : "outlets";
    };    

    return (<>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '6px 16px',
        boxShadow: '0 -2px 4px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{ display: 'flex', gap: '20px' }}>
          <div>
            <div style={{ fontSize: '12px', color: '#7C7C7C' }}>Claim Amount</div>
            <div style={{ fontWeight: 600, fontSize: '16px', color: '#000' }}>
              {accordionData?.claimAmount || 0}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '12px', color: '#7C7C7C' }}>Approved Claim Amount</div>
            <div style={{ fontWeight: 600, fontSize: '16px', color: '#000' }}>
              {currency} {formatDecimal(getTotalApprovedAmount())}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            style={{
              backgroundColor: '#C44C36',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '10px 16px',
              fontSize: '14px',
              fontWeight: 500,
              cursor: hasSelectedRows && canApproveReject ? 'pointer' : 'not-allowed',
              opacity: hasSelectedRows && canApproveReject ? (isSubmitting ? 0.7 : 1) : 0.5
            }}
            onClick={() => hasSelectedRows  && canApproveReject && handleRejectClick()}
            disabled={!hasSelectedRows || !canApproveReject || isSubmitting}
            title={!canApproveReject ? "Claim is locked for editing" : ""}
          >
            Reject
          </button>
          <button
            style={{
              backgroundColor: '#00C6B1',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '10px 16px',
              fontSize: '14px',
              fontWeight: 500,
              cursor: hasSelectedRows && canApproveReject ? 'pointer' : 'not-allowed',
              opacity: hasSelectedRows && canApproveReject ? (isSubmitting ? 0.7 : 1) : 0.5
            }}
            onClick={() => hasSelectedRows && canApproveReject && handleApproveAll()}
            disabled={!hasSelectedRows || !canApproveReject || isSubmitting}
            title={!canApproveReject ? "Claim is locked for editing" : ""}
          >
            Approve
          </button>
        </div>
      </div>
      <ClaimRejectionModal
        isOpen={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        heading={(accordionData.claimType === claimTypes[0]) ?
          "Enter the reasons for rejected qty in SKUs" :
          (accordionData.typeOfExpense === claimSubTypes[2]) ?
          "Enter the reasons for rejected claim amount of SKUs" :
          (accordionData.claimType === claimTypes[2]) ?
          "Enter the reasons for rejected claim amount" :
          "Enter the reasons for rejected claim amount of invoices"}
        selectedBatches={[]}
        onConfirm={handleRejectWithReasons}
        openClaimsRows={openClaimsRows.filter((row: any) =>
          saleReturnsCheckedClaimIds.includes(row.id) && !(row.status === "REJECTED") && !areAllRejected(row)
        )}
        isBulkRejection={true}
        claimType={accordionData.claimType}
        areAllRejected={(row:any) => areAllRejected(row)}
        approvalConfig={approvalConfig}
      />
      <ClaimActionConfirmationModal
        approvalModalOpen={approvalModalOpen}
        setApprovalModalOpen={setApprovalModalOpen}
        approvalModalState={approvalModalState}
        setApprovalModalState={setApprovalModalState}
        getPostBody={getPostBodyWithRef}
        postBodyRef={postBodyRef}
        approvalConfig={approvalConfig}
        approvalText = {approvalModalState === 3 ? (
          "An error occurred during submission."
        ) : approveModalType === "full" ? (
          "Are you sure you want to approve the claim?"
        ) : approveModalType === "partial" ? (
          <div style={{ lineHeight: '1.6' }}>
            <div>Are you sure you want to approve the claim?</div>
            <div style={{ marginTop: '12px' }}>
            <span style={{ fontWeight: 550 }}>Note:</span> Action is still pending for {pendingItemsCount} {getPendingItemLabel()}.<br />
              If you proceed, the remaining {getPendingItemLabel()} will be auto-approved upon claim submission.
            </div>
          </div>
        ) : approveModalType === "rejectFull" ? (
          "Are you sure you want to reject the claim?"
        ) : (
          <div style={{ lineHeight: '1.6' }}>
            <div>Are you sure you want to reject the claim?</div>
            <div style={{ marginTop: '12px' }}>
              <span style={{ fontWeight: 550 }}>Note:</span> Action is still pending for {pendingItemsCount} {getPendingItemLabel()}.<br />
              If you proceed, the remaining {getPendingItemLabel()} will be auto-approved upon claim submission.
            </div>
          </div>
        )}
        
        approvalMessage={
          approvalModalState === 2 &&
            (approveModalType === "full" || approveModalType === "partial")
            ? (<>Claim ID <span style={{ fontWeight: 600 }}>{claimId}</span> has been approved successfully</>)
            : (<>Claim ID <span style={{ fontWeight: 600 }}>{claimId}</span> has been rejected successfully</>)
        }
        isOpenClaimsPage={true}
        handleSubmit={
          approveModalType === "rejectFull" || approveModalType === "rejectPartial"
            ? handleRejectionSubmit
            : handleApprovalSubmit
        }
        errorMessage={errorMessage} 
        setErrorMessage={setErrorMessage} 
        claimType={accordionData.claimType}
        claimSubtype={accordionData.typeOfExpense}
        distributorId={accordionData.distributorId}
      />
    </>
    );
  };  
  if (loader) {
    return <Loader />;
  }

  if (!loader && Object.keys(data).length === 0) {
    return <h3>No information exist with id: {claimId}</h3>;
  }

  return (
    <>
      {isStatusModalOpen && (
        <ClaimDetailsModal
          isOpen={isStatusModalOpen}
          onClose={handleCloseModal}
          claimId={claimId}
          status={accordionData.status}
          claimType={accordionData.claimType}
          typeOfExpense={accordionData.typeOfExpense}
          data={selectedOpenClaimsRow}
          statusConfig={actionButtons}
          approvalConfig={approvalConfig}
        />
      )}
      <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message={popUpMessage}
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={popUpSuccessMethod.current}
      />
      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />
      <div className="view-primary-order-parent-vo" style={secondLastSegment === "open" ? { gap: "0px", width: "100%" } : {width: "100%"}} onWheel={(e) => handleScrollCustomDataGrid(e, setIsScrolling)}>
        <div className="view-primary-order-header">
          <FormHeader
            parentLabel={secondLastSegment==="open" ? "Open Claims" : "Closed Claims"}
            label={"Claim ID Details"}
            goBackToParent={() => navigate(-1)}
          />
          <div>
            <TextField
              id="outlined-basic"
              label="Search"
              variant="outlined"
              size="small"
              sx={{ width: "230px" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <div className="search-icon-wrapper">
                      <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </div>
                  </InputAdornment>
                ),
              }}
              autoComplete="off"
              value={searchValue}
              onChange={(e) => {
                filterData(e.target.value);
              }}
            />
          </div>
        </div>
        {(secondLastSegment === "open") && approvalConfig?.flow && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              {approvalConfig.flow.slice(approvalConfig.lowestLevel || 0).map((levelDesignations, levelIndex) => {
                const actualLevelIndex = (approvalConfig.lowestLevel || 0) + levelIndex;
                let levelStatus = 'PENDING';
                const approvalsForLevel = [];

                for (const row of openClaimsRows) {
                  if (row.approvals) {
                    for (const approval of row.approvals) {
                      if (levelDesignations.includes(approval.designation)) {
                        approvalsForLevel.push(approval);
                      }
                    }
                  }
                  if (row.batchIds) {
                    for (const batch of row.batchIds) {
                      if (batch.approvals) {
                        for (const approval of batch.approvals) {
                          if (levelDesignations.includes(approval.designation)) {
                            approvalsForLevel.push(approval);
                          }
                        }
                      }
                    }
                  }
                  if (row.invoices) {
                    for (const invoice of row.invoices) {
                      if (invoice.approvals) {
                        for (const approval of invoice.approvals) {
                          if (levelDesignations.includes(approval.designation)) {
                            approvalsForLevel.push(approval);
                          }
                        }
                      }
                    }
                  }
                }

                if (approvalsForLevel.length > 0) {
                  if (approvalsForLevel.every(a => a.status !== 'PENDING')) {
                    levelStatus = 'Approved';
                  } else if (approvalsForLevel.some(a => a.status !== 'PENDING')) {
                    levelStatus = 'PartiallyApproved';
                  }
                }

                return (
                  <div key={actualLevelIndex} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <div style={{
                      width: '22px',
                      height: '22px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: levelStatus === 'PENDING' ? '#FFF9EF' : '#E8F5E9',
                      border: levelStatus === 'PENDING' ? '1px solid #CC911F' : '1px solid #4CAF50'
                    }}>
                      {levelStatus === 'PENDING' ? (
                        <AccessTimeIcon style={{ color: '#CC911F', fontSize: '16px' }} />
                      ) : (
                        <CheckIcon style={{ color: '#4CAF50', fontSize: '16px' }} />
                      )}
                    </div>
                    <span style={{ fontSize: '14px', color: levelStatus === 'PENDING' ? '#CC911F' : '#4CAF50', fontWeight: 500 }}>
                      {levelDesignations[0]}
                    </span>
                    {actualLevelIndex < approvalConfig.flow.length - 1 && (
                      <span style={{ color: '#7C7C7C' }}>---</span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div style={{
          display: "flex",
          height: "100%",
          gap: "6px"
        }}>
          <div style={{
            width: isModalOpen ? "55%" : "100%",
          }}>
            <CustomAccordian
              expanded={!isScrolling}
              onCustomAccordionToggle={onCustomAccordionToggle}
              isSecondHalf={true}
              metaData1={viewClaimMetaData1}
              data1={accordionData}
              metaData2={viewClaimMetaData2(currency, accordionData?.status, accordionData?.claimType, accordionData?.typeOfExpense, actionButtons)}
              data2={accordionData}
              label1=""
              metaData1ChunkSize={5}
              metaData2ChunkSize={5}
              header={`Claim ID. ${claimId}`}
              statusConfig={secondLastSegment==="open" ? [{
                "id": "Requested",
                "dmsColor": "#FFF9EF",
                "dmsLabel": "Pending",
                "dmsLabelColor": "#CC911F"
              }]: actionButtons}
              status={accordionData?.status}
              singleColumnInEachHalf={true}
            />
            <div className="order-details-vo" style={{
              height: isScrolling ? "calc(100% - 30px)" : "calc(100% - 135px)",
              overflow: "auto",
              maxHeight: "100%",
              position: "relative"
            }}>                  
            <div
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-start",
                marginTop: "0.75rem"
              }}
            >
                <Header title={accordionData?.claimType === claimTypes[2] ? "Outlet Details" : accordionData?.typeOfExpense === claimSubTypes[3] ? "Invoice Details" : "SKU Details"} />
              </div>
              {loader ? (
                <Loader />
              ) : (
                  <CustomDataGrid
                    rows={filteredRows}
                    columnsMetaData={claimsDetailsColumnsMetaData}
                    {...(accordionData?.typeOfExpense !== claimSubTypes[3]
                      ? {
                        onRowClick: handleRowClick,
                        selectedRowId: selectedOpenClaimsRow?.id,
                        insideOpenClaimsDetails: true
                      }
                      : {
                        onEditClick: handleOpenModal,
                        insideOpenClaimsDetails: false
                      })}
                      tableWidth={
                        sidebarCollapsed && isModalOpen
                          ? 0.45
                          : secondLastSegment === "open" &&
                            isModalOpen &&
                            (accordionData?.typeOfExpense === claimSubTypes[1] ||
                              accordionData?.claimType === claimTypes[1] ||
                              accordionData?.claimType === claimTypes[2])
                          ? 0.45
                          : 0.75
                      }                      
                    {...(secondLastSegment === "open"
                      ? {
                        isCheckboxSelection: true,
                        checkedIdArray: saleReturnsCheckedClaimIds,
                        setCheckedIdArray: handleSetCheckedIdArray,
                        footerElement: () => <ClaimFooter />,
                        insideOpenClaimsDetails: true,
                        rowIdsWithCheckboxHidden: saleReturnsClaimIdsCheckboxHidden
                      }
                      : {})}
                  />
              )}
            </div>
          </div>
          <OpenClaimsDetailsModal
            key={selectedOpenClaimsRow?.id}
            isOpen={isModalOpen}
            onClose={() => {
              setIsModalOpen(false);
              dispatch(setSelectedOpenClaimsRow(null));
            }}
            accordionData={accordionData}
            updateSelectedRowInRows={updateSelectedRowInRows}
            statusConfig={actionButtons}
            setIsModalOpen={setIsModalOpen}
            handleSetCheckedIdArray={handleSetCheckedIdArray}
            openClaimsOthersUIConfig={openClaimsOthersUIConfig}
            canApproveReject={canApproveReject}
            approvalConfig={approvalConfig}
          />
        </div>
      </div>
    </>
  );
};

export default OpenClaimsDetails;